import ServiceExec from '@/common/utils/ServiceExec';
import PaymentApi from '@/common/service/apis/PaymentApi';

class PaymentSvc extends ServiceExec {
  getPaymentList(params = {}) {
    return this.get(PaymentApi.getPaymentList, params)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        console.log('getPaymentList error: ', error);
      });
  }

  getPaymentDetail(studentOrderNo) {
    return this.patch(PaymentApi.getPaymentDetail(studentOrderNo))
      .then(response => {
        return response.data;
      })
      .catch(error => {
        console.log('getPaymentDetail error: ', error);
      });
  }
}
export default new PaymentSvc();
